import React from 'react'
import { GiftsList } from './list/page'
export const GiftsPage = () => {
  return <GiftsList />
}
